import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CampaignService} from '../../campaign/service/campaign.service';
import {DataAvailabilityService} from '../data-availability-service/dataavailability.service';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../../environments/environment';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-availabledata-view',
  templateUrl: './dataavailability-view.component.html',
  styleUrls: ['./dataavailability-view.component.css']
})
export class DataAvailabilityViewComponent implements OnInit {

  loading: boolean;
  dataAvailabilityList: any [];
  campaignId: any;
  campaignNumber: any;
  currentCampaign: any;
  clientId: any;
  startDate: any;
  endDate: any;
  itemsPageCount = 1;
  itemsPerPage = 10;
  currentPage = 1;

    constructor(private router: Router,
              private dataavailabilityService: DataAvailabilityService,
              private campaignService: CampaignService, public datePipe: DatePipe,
              private toastr: ToastrService, private _route: ActivatedRoute) {

        this._route.queryParams.subscribe(params => {
          this.campaignId = params['campaignId'] || '';
          this.campaignNumber = params['campaignNumber'] || '';
        });

        this._route.params.subscribe(routeParams => {this.clientId = routeParams.clientIdParam; });
        this.clientId = this.clientId !== undefined ? this.clientId : localStorage.getItem('clientId');

  }

  ngOnInit() {
    this.getCampaign(this.campaignId);
  }

  getCampaign(campaignId) {

        this.campaignService.getCampaignsDetails(campaignId).subscribe(data => {
            //console.log('campaign ::' + data.json());
            this.currentCampaign = data.json();
            this.getAllDataAvailable();
          }, (error) => {
            //this.toastr.error('', 'Please try again');
          });

  }

  pageChanged(event) {
        this.currentPage = event;
        this.getAllDataAvailable();
        console.log(event);
    }

  public getAllDataAvailable() {
    this.loading = true;
      if (this.clientId === undefined) {
          this.clientId = localStorage.getItem('clientId');
      }

    if(this.startDate===null || this.startDate===undefined){
        this.startDate = this.currentCampaign.startDate;
    }
    if(this.endDate===null || this.endDate===undefined){
        if(this.currentCampaign.expiryDate!== undefined || this.currentCampaign.expiryDate !==null){
            this.endDate = this.currentCampaign.expiryDate;
        }

    }
    this.dataavailabilityService.getAllDataAvailable(this.campaignId, this.datePipe.transform(this.startDate, 'yyyyMMddHHmmss'), this.datePipe.transform(this.endDate, 'yyyyMMddHHmmss'), this.currentPage -1 , this.itemsPerPage)
        .subscribe(data => {
          const response: any = data.json();
          this.dataAvailabilityList = response.dataAvailabilityList;
          this.loading = false;
          // TODO - Uncomment below code when using actual API
          // const response: any = data;
          // if (response.status === 200) {
          //   this.userList = response.result;
          // } else {
          //   this.toastr.error('', 'Please try again');
          // }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

    viewHistoryData(campaignId, deviceId,start, endDate) {

    this.router.navigate([ '/elasticcare/history-data' ], { queryParams: { campaignId: campaignId, deviceId: deviceId, start: this.datePipe.transform(start, "yyyy-MM-dd'T'HH:mm:ss")}});
  }

}
